export const DEFAULT_TRANSLATION = {
  means: 'means',
  clickSelect: 'Click to select rating',
  continueButton: 'Continue',
  skipButton: 'Skip',
  okButton: 'OK',
  arialContinue: 'Continue survey',
  arialSkip: 'Click to skip this question',
  arialOk: 'Click to go to next question',
  required: 'required',
};
